var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{class:_vm.$style.tabsList},_vm._l((_vm.paymentList),function(item,index){return _c('TabsItem',{key:index,attrs:{"itemData":item},on:{"change:tabsItem":_vm.changeTabsItem}})}),1),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }